import { React, useEffect, useState } from "react";
import {
  Button,
  Divider,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Tab,
  Tabs,
  Typography,
  Autocomplete,
  IconButton,
  TextField,
} from "@mui/material";
import { CloudUpload, Download } from "@mui/icons-material";
import { Box, useTheme } from "@mui/system";
import { read, readFile, utils } from "xlsx";
import AppButton from "../../../../../base/AppButton.component";
import { InputValidation } from "../../../../../../utils/InputValidationRegex";
import { DialogStyle } from "./Dialog.styles";
import { GET_CALL_COUNT } from "../../../../../../graphql/query/query";
import { useAuth } from "../../../../../../context/Auth.context";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../../../../../context/App.context";
import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_USER,
  IMPORT_USERS,
  MANAGE_ASSOCIATION,
  UPDATE_USER,
} from "../../../../../../graphql/mutation/mutation";
import { CheckCircle } from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  firstOfMonth,
  today,
  userTemplateURL,
} from "../../../../../../utils/Utils";
import moment from "moment";
import AddNewUserComponent from "../../AddNewUser.component";
import { SEARCH_MANAGER } from "../../../../../../graphql/query/query";
import { mt } from "date-fns/locale";
import ImportUserDialog from "./ImportUser.dialog";

let importUser = [];
const INITIAL_FILTER = {
  startDate: moment(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  ).format("MM/DD/YYYY"),
  endDate: moment(new Date()).format("MM/DD/YYYY"),
};
// console.log("user", importUser);

const AddNewUserDialog = (props) => {
  const theme = useTheme();
  const auth = useAuth();
  const params = useParams();
  const app = useAppContext();
  const [isSaved, setSaved] = useState(false);
  const [filterData, setFilterData] = useState(INITIAL_FILTER);
  const [activeTab, setActiveTab] = useState(0);
  const [managerAssociatedMessage, setManagerAssociatedMessage] = useState("");

  // State for associate manager section
  const [associateFilter, setAssociateFilter] = useState({
    email: "",
    dealership_id: params.dealershipId || auth?.user?.dealership_id,
  });

  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    designation: "manager",
    receiveNotification: 3,
    verifyNotification: 3,
    appointmentNotification: 3,
    reviewNotification: 3,
    referralNotification: 3,
    knowledgeHubNotification: 3,
    csiNotification: 3,
    prequalNotification: 3,
    idVerificationNotification: 3,
    appDownloadNotification: 3,
    // assignTarget: 0,
    fileName: "",
    file: null,
    verification_workflow_id: 1,
  });

  const [createUser, { loading: createLoading, data: createdUser }] =
    useMutation(CREATE_USER);
  const [updateUser, { loading: updateLoading, data: updatedUser }] =
    useMutation(UPDATE_USER);
  const [importUsers, { loading: importLoading, data: UsersImport }] =
    useMutation(IMPORT_USERS);

  const [manageAssociation, { loading: associateLoading }] = useMutation(
    MANAGE_ASSOCIATION,
    {
      onCompleted: (data) => {
        data?.manageAssociation?.employee_user_id == null
          ? setManagerAssociatedMessage("Manager / Employee Already Associated")
          : setManagerAssociatedMessage("Manager / Employee associated successfully");
        setTimeout(() => {
          setManagerAssociatedMessage("");
        }, 5000);
      },
    }
  );

  const { update, edit = false } = props;

  // Query for searching managers
  const { loading: searchLoading, data: SearchData } = useQuery(
    SEARCH_MANAGER,
    {
      skip: activeTab !== 2, // Only run query when tab 2 is active
      variables: {
        searchInput: {
          dealership_id: associateFilter.dealership_id,
          email: associateFilter.email,
        },
      },
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
    }
  );

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

const handleFileSelection = async (event) => {
  const selectedFile = event.target.files[0];
   
  if (selectedFile) {
    const reader = new FileReader();
    const fileName = selectedFile.name;
    setUser({ ...user, fileName: fileName });
    reader.readAsBinaryString(selectedFile);
    reader.onload = async (e) => {
      const fileData = e.target.result;
      const workbook = read(fileData, { type: "binary" });
      const sheetName = workbook.SheetNames[1];
      const worksheet = workbook.Sheets[sheetName];

      // Clear previous imports first
      importUser = []; // ADD THIS LINE
      
      let data = utils.sheet_to_json(worksheet, { header: 1 });
      
      // Remove header row
      data.shift();
      
      // Filter out empty rows - CHANGE THIS PART
      data = data.filter((element) => {
        // Check if row has any data in required columns (e.g., first name in column 1)
        return element && element.length > 0 && element[1] && element[1].toString().trim() !== '';
      });
      
      console.log("Filtered data:", data);
      
      // Use forEach instead of map since we're not returning anything
      data.forEach((element) => {
        // No need for if check here since we already filtered above
        let newUser = {
          first_name: "",
          last_name: "",
          // middle_name: "",
          email: "",
          mobile_number: "",
          role: "",
          verification_preference: "",
          appointment_preference: "",
          notification_preference: "",
          review_preference: "",
          referral_preference: "",
          knowledge_hub_preference: "",
          csi_preference: "",
          prequal_preference: "",
          id_verification_preference: "",
          app_download_preference: "",
          // current_target: "",
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: params.dealershipId,
          employee_user_id: null,
          d_startDate: firstOfMonth,
          d_endDate: today,
          f_startDate: firstOfMonth,
          f_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          verification_workflow_id: "1",
          isAdmin: true,
        };
        
        newUser = {
          ...newUser,
          first_name: element[1] || "",
          last_name: element[2] || "",
          email: element[3] || "",
          mobile_number: element[4] || "",
          role: element[5] || "",
          verification_workflow_id:
            element[6] == "OFFER QUOTE ONLY"
              ? 3
              : element[6] == "VERIFY ONLY"
                ? 2
                : 1,
          verification_preference:
            element[7] == "EMAIL" ? 1 : element[7] == "TEXT" ? 2 : 3,
          notification_preference:
            element[8] == "EMAIL" ? 1 : element[8] == "TEXT" ? 2 : 3,
          review_preference:
            element[9] == "EMAIL" ? 1 : element[9] == "TEXT" ? 2 : 3,
          appointment_preference:
            element[10] == "EMAIL" ? 1 : element[10] == "TEXT" ? 2 : 3,
          referral_preference:
            element[11] == "EMAIL" ? 1 : element[11] == "TEXT" ? 2 : 3,
          knowledge_hub_preference:
            element[12] == "EMAIL" ? 1 : element[12] == "TEXT" ? 2 : 3,
          csi_preference:
            element[13] == "EMAIL" ? 1 : element[13] == "TEXT" ? 2 : 3,
          prequal_preference:
            element[14] == "EMAIL" ? 1 : element[14] == "TEXT" ? 2 : 3,
          id_verification_preference:
            element[15] == "EMAIL" ? 1 : element[15] == "TEXT" ? 2 : 3,
          app_download_preference:
            element[16] == "EMAIL" ? 1 : element[16] == "TEXT" ? 2 : 3,
          // current_target: element[8],
        };

        importUser.push(newUser);
      });
      
      console.log("Final importUser:", importUser);
    };
  }
};
  

  // Handler for associate manager section
  const handleChange = (event, newValue) => {
    setAssociateFilter({ ...associateFilter, email: newValue });
  };

  const handleAssociation = (email) => {
    manageAssociation({
      variables: {
        associateInput: {
          dealership_id: params.dealershipId || auth?.user?.dealership_id,
          email: email,
          associate: true,
          d_startDate: firstOfMonth,
          d_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          isAdmin: true,
          created_by: parseInt(auth?.user?.user_id),
          updated_by: parseInt(auth?.user?.user_id),
        },
      },
    });
  };

  useEffect(() => {
    if (update) {
      setUser({
        firstName: update.first_name,
        lastName: update.last_name,
        email: update.email,
        mobileNumber: update.mobile_number,
        designation: update.role,
        receiveNotification: update.notification_preference,
        verifyNotification: update.verification_preference,
        appointmentNotification: update.appointment_preference,
        reviewNotification: update.review_preference,
        referralNotification: update.referral_preference,
        knowledgeHubNotification: update.knowledge_hub_preference,
        csiNotification: update.csi_preference,
        prequalNotification: update.prequal_preference,
        idVerificationNotification: update.id_verification_preference,
        appDownloadNotification: update.app_download_preference,
        // assignTarget: update.assigned_target,
        userId: update.employee_user_id,
        verification_workflow_id: update?.verification_workflow_id,
      });
    }
  }, [update]);

  useEffect(() => {
    if (createdUser) {
      setSaved(true);
    }
    if (updatedUser) {
      setSaved(true);
    }
    if (UsersImport) {
      setSaved(true);
    }
  }, [createdUser, updatedUser, setSaved, UsersImport]);

  const createUserHandler = () => {
    if (user.fileName) {
      if (importUser.length > 0)
        importUsers({
          variables: {
            importInput: {
              dealership_id: params.dealershipId,
              users: importUser,
            },
          },
        });
    } else {
      createUser({
        variables: {
          createUserInput: {
            first_name: user.firstName,
            last_name: user.lastName,
            // middle_name: "",
            email: user.email,
            mobile_number: user.mobileNumber.replace(/\D/g, ""),
            role: user.designation,
            notification_preference: user.receiveNotification,
            verification_preference: user.verifyNotification,
            appointment_preference: user.appointmentNotification,
            review_preference: user.reviewNotification,
            referral_preference: user.referralNotification,
            knowledge_hub_preference: user.knowledgeHubNotification,
            csi_preference: user.csiNotification,
            prequal_preference: user.prequalNotification,
            id_verification_preference: user.idVerificationNotification,
            app_download_preference: user.appDownloadNotification,

            // current_target: user.assignTarget,
            created_by: auth.user.user_id,
            updated_by: auth.user.user_id,
            dealership_id: params.dealershipId,
            employee_user_id: null,
            d_startDate: firstOfMonth,
            d_endDate: today,
            f_startDate: firstOfMonth,
            f_endDate: today,
            timezone: new Date().getTimezoneOffset(),
            is_active: true,
            verification_workflow_id: user?.verification_workflow_id,
            isAdmin: true,
          },
        },
      });
    }
  };

  const updateUserHandler = () => {
    updateUser({
      variables: {
        createUserInput: {
          user_id: user.userId,
          first_name: user.firstName,
          last_name: user.lastName,
          email: user.email,
          mobile_number: user.mobileNumber.replace(/\D/g, ""),
          notification_preference: user.receiveNotification,
          verification_preference: user.verifyNotification,
          appointment_preference: user.appointmentNotification,
          role: user.designation,
          review_preference: user.reviewNotification,
          referral_preference: user.referralNotification,
          knowledge_hub_preference: user.knowledgeHubNotification,
          csi_preference: user.csiNotification,
          prequal_preference: user.prequalNotification,
          id_verification_preference: user.idVerificationNotification,
          app_download_preference: user.appDownloadNotification,
          // current_target: user.assignTarget,
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: params.dealershipId,
          employee_user_id: null,
          d_startDate: firstOfMonth,
          d_endDate: today,
          f_startDate: firstOfMonth,
          f_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          is_active: true,
          verification_workflow_id: user?.verification_workflow_id,
          isAdmin: true,
        },
      },
    });
  };

  return (
    <>
      <Divider />

      {/* Three Button Section - Added after first divider */}
      <Box
        sx={{
          display: "flex",
          alignContent: "start",
          alignItems: "start",
          justifyContent: "space-between",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="minimal"
          aria-label="user management tabs"
        >
          <Tab label="Create User" />
          <Tab label="Import User" />
          <Tab label="Associate Manager / Employee" />
        </Tabs>
      </Box>

      {/* Tab content */}
      {activeTab === 0 && (
        <Box sx={{ p: "16px", height: "550px", overflow: "auto" }}>
          <AddNewUserComponent />
        </Box>
      )}
      {activeTab === 1 && (
        <Box sx={{ p: "16px", height: "550px", overflow: "auto" }}>
       <ImportUserDialog />
        </Box>
      )}

      {activeTab === 2 && (
        <Box
          sx={{
            p: "16px",
            height: "550px",
            overflow: "auto",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          {/* Associate Manager Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              width: "100%",
            }}
          >
            {/* <Typography variant="h6">Associate Manager</Typography> */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "8px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <Autocomplete
                options={(SearchData?.searchManager?.removeExistingEmail || [])
                  .map((item) => String(item))
                  .sort((a, b) => a.localeCompare(b))}
                sx={{ width: "70%" }}
                onChange={handleChange}
                getOptionLabel={(option) => String(option)}
                loading={searchLoading}
                renderInput={(params) => (
                  <div>
                    <TextField {...params} label="Search Manager / Employee *" />
                    {managerAssociatedMessage && (
                      <FormHelperText
                        sx={{
                          color: theme.palette.primary.main,
                        }}
                      >
                        <span>{managerAssociatedMessage}</span>
                      </FormHelperText>
                    )}
                  </div>
                )}
              />
              <IconButton
                sx={{
                  width: "12%",
                  height: "40px",
                  borderRadius: "4px",
                  ml: 25,
                  mt: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor:
                    associateLoading ||
                    associateFilter?.email == "" ||
                    InputValidation.emailValidation(associateFilter?.email)
                      ? "action.disabledBackground"
                      : "primary.main",
                  "&:hover": {
                    backgroundColor:
                      associateLoading ||
                      associateFilter?.email == "" ||
                      InputValidation.emailValidation(associateFilter?.email)
                        ? "action.disabledBackground"
                        : "primary.dark",
                  },
                  "&:disabled": {
                    backgroundColor: "action.disabledBackground",
                  },
                }}
                color="inherit"
                aria-label="associate user"
                onClick={() => handleAssociation(associateFilter.email)}
                disabled={
                  associateLoading ||
                  associateFilter?.email == "" ||
                  InputValidation.emailValidation(associateFilter?.email)
                }
              >
                <Box
                  component="span"
                  sx={{
                    color: "common.white",
                    fontSize: "15px", // Slightly smaller for better fit
                    // fontWeight: 600,
                    textTransform: "uppercase",
                    // letterSpacing: "0.5px",
                    // lineHeight: 1.2
                  }}
                >
                  Associate
                </Box>
              </IconButton>
            </Box>
            {/* <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Box sx={{ flexGrow: 1, height: "1px", backgroundColor: "#E0E0E0" }}></Box>
      <Typography color="textSecondary">OR</Typography>
      <Box sx={{ flexGrow: 1, height: "1px", backgroundColor: "#E0E0E0" }}></Box>
    </Box> */}
            {/* <Box sx={{ p: "16px" }}>
      <AddNewUserComponent
        edit={false}
      />
    </Box> */}
          </Box>
        </Box>
      )}
    </>
  );
};

export default AddNewUserDialog;
